import React from "react";
import { HeaderSection, SubSection, SubSectionSpaced } from "components/attributes/panels/components/read-only-sections";
import ThreeWayCheckbox from "components/form-inputs/boolean";

export const ReadOnlyEnergyPanel = ({ value }) => {
    return (
        <div className="container">
            <div className="panel read-only">
                <HeaderSection label="Energy Facts" />

                <SubSectionSpaced leftLabel="Model number" rightLabel={value.modelNumber} />

                <SubSectionSpaced leftLabel="Capacity" rightLabel={value.capacity} separatorVariant="thick" />

                {value.ranges.length > 0 && (
                    <SubSection label="Slider range" headerVariant="big">
                        {value.ranges.map(({ sliderTitle, selectedValue, low, high, label, labelRange, legendText }, index) => {
                            const values = selectedValue.map(({ value: rangeValue, uom }) => `${rangeValue} ${uom.text}`).join(", ");

                            return (
                                <div key={index}>
                                    <SubSection label="Slider Title" separatorVariant="none">
                                        <div>{sliderTitle}</div>
                                    </SubSection>

                                    <SubSectionSpaced leftLabel="Selected values" rightLabel={values} separatorVariant="thick" disableBp disableBm />

                                    {low && high && (
                                        <SubSection label="Ranges" separatorVariant="none">
                                            <SubSectionSpaced leftLabel={`${low.value} ${low.uom.text}`} rightLabel={`${high.value} ${high.uom.text}`} separatorVariant="none" disablePb disableMb headerVariant="small" />
                                            {(label || labelRange) && <SubSectionSpaced leftLabel={label} rightLabel={labelRange} separatorVariant="none" disablePb disableMb headerVariant="small" />}
                                        </SubSection>
                                    )}

                                    <SubSection label="Legend" separatorVariant="none" headerVariant="small">
                                        {legendText}
                                    </SubSection>
                                </div>
                            );
                        })}
                    </SubSection>
                )}

                {value.legalTerms && (
                    <SubSection label="Legal Terms" separatorVariant="none">
                        <div>{value.legalTerms}</div>
                    </SubSection>
                )}

                {value.governmentWebsite && (
                    <SubSection label="Government Website" separatorVariant="none">
                        <div>{value.governmentWebsite}</div>
                    </SubSection>
                )}

                {value.additionalProductDetails && (
                    <SubSection label="Additional Product Details" separatorVariant="none">
                        <div>{value.additionalProductDetails}</div>
                    </SubSection>
                )}

                <div className="checkbox-column">
                    <div className="align-center">
                        <ThreeWayCheckbox readOnly={true} defaultValue={value.hasEnergyStarLogo} />
                        <div>Energy Star Logo</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
